import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { IsActiveMatchOptions, Router } from '@angular/router';
import { FuseNavigationService } from '@fuse/components/navigation/navigation.service';
import { FuseNavigationItem } from '@fuse/components/navigation/navigation.types';
import { FuseUtilsService } from '@fuse/services/utils';
import { LOG } from '@shared/components/err/Logger';
import { environment } from 'environments/environment';
import { Subject, takeUntil } from 'rxjs';
import Swal from 'sweetalert2';
import { FuseVerticalNavigationComponent } from '../../vertical.component';

@Component({
  selector: 'app-superset-fuse-node',
  templateUrl: './superset.component.html',
  styleUrl: './superset.component.scss'
})
export class SupersetComponent {
     @Input() item: FuseNavigationItem;
      @Input() name: string;
      
      id_dashboard : string = '';
  
      mostrarSpinner : boolean = false;
  
      isActiveMatchOptions: IsActiveMatchOptions;
      private _fuseVerticalNavigationComponent: FuseVerticalNavigationComponent;
      private _unsubscribeAll: Subject<any> = new Subject<any>();
  
  
      /**
       * Constructor
       */
      constructor(
          private _changeDetectorRef: ChangeDetectorRef,
          private _fuseNavigationService: FuseNavigationService,
          private _fuseUtilsService: FuseUtilsService,
          private router:Router
      )
      {

          this.isActiveMatchOptions = this._fuseUtilsService.subsetMatchOptions;
      }
  
      // -----------------------------------------------------------------------------------------------------
      // @ Lifecycle hooks
      // -----------------------------------------------------------------------------------------------------
  
      /**
       * On init
       */
      ngOnInit(): void
      {

        console.log(this.item)
  

          this.isActiveMatchOptions =
              this.item.isActiveMatchOptions ?? this.item.exactMatch
                  ? this._fuseUtilsService.exactMatchOptions
                  : this._fuseUtilsService.subsetMatchOptions;
  
          // Get the parent navigation component
          this._fuseVerticalNavigationComponent = this._fuseNavigationService.getComponent(this.name);
  
          // Mark for check
          this._changeDetectorRef.markForCheck();
  
          // Subscribe to onRefreshed on the navigation component
          this._fuseVerticalNavigationComponent.onRefreshed.pipe(
              takeUntil(this._unsubscribeAll)
          ).subscribe(() => {
  
              // Mark for check
              this._changeDetectorRef.markForCheck();
          });
      }

      goTo(link: string) {
  const [, secondPart] = link.split('/');
  this.router.navigateByUrl(`/superset/${secondPart}`);
}

  
      /**
       * On destroy
       */
      ngOnDestroy(): void
      {
          // Unsubscribe from all subscriptions
          // this._unsubscribeAll.next(null);
          // this._unsubscribeAll.complete();
      }
  
      callSuperset(item){

        console.log(item)
          if(item.link){

            this.id_dashboard = item.link
 
  
          }else{
              Swal.fire('Error','No hay endpoint asociado','error')
          }
      }

}
